import React, { useState } from 'react';
import Button from '../UI/Button';

const priorityMap = {
	High: 'text-red-600',
	Medium: 'text-yellow-600',
	Low: 'text-green-600'
};

export default function SuggestionCard({ suggestion = {}, onApply }) {
	const [open, setOpen] = useState(false);
	const title = suggestion.title || suggestion;
	const description = suggestion.description || '';
	const priority = suggestion.priority || 'Medium';

	return (
		<div className="border rounded-md p-3">
			<div className="flex items-center justify-between">
				<div>
					<p className="font-semibold">{title}</p>
					<p className={`text-xs ${priorityMap[priority] || 'text-gray-500'}`}>Priority: {priority}</p>
				</div>
				<div className="flex items-center gap-2">
					<Button size="sm" variant="ghost" onClick={() => setOpen((v) => !v)}>
						{open ? 'Hide' : 'Details'}
					</Button>
					<Button size="sm" onClick={onApply}>
						Apply to Resume
					</Button>
				</div>
			</div>
			{open && <p className="mt-2 text-sm text-gray-700 whitespace-pre-wrap">{description}</p>}
		</div>
	);
}


